module.exports = __webpack_public_path__ + "static/bsas014.thumb-6e3aa998a745c6053377522a4722d6dd.jpg";